<template>
  <div>
    <AppNavbar />
    <div class="faq-page-root">
      <div class="hero-full-bleed-row">
        <section class="faq-hero">
          <div class="hero-content reveal">
            <p class="eyebrow">Support</p>
            <h1>
              IndieKonnect Enterprises Private Limited: <br />
              Frequently Asked Questions (FAQs)
            </h1>
          </div>
        </section>
      </div>

      <div class="content-full-bleed-row">
        <section class="faq-section">
          <div class="faq-wrapper">
            <div class="policy-block reveal">
              <div class="at-a-glance">
                <p>
                  <strong>IndieKonnect</strong> Enterprises Private Limited is a
                  legally incorporated Direct Selling company in India. It
                  operates in strict adherence to the Companies Act, 2013, and
                  the Consumer Protection (Direct Selling) Rules, 2021. The
                  company provides a legitimate business opportunity centered on
                  the sale of lifestyle products through an independent network
                  of Brand Affiliates.
                </p>
              </div>
            </div>

            <!-- Section 1 -->
            <div class="policy-block reveal">
              <h3>Section 1: Company Legality & Incorporation</h3>

              <div class="faq-item">
                <p class="faq-q">
                  Q: Is IndieKonnect Enterprises Private Limited a legally
                  registered company?
                </p>
                <p class="faq-a">
                  A: Yes. IndieKonnect was incorporated on June 20, 2026, under
                  the Companies Act, 2013.
                </p>
                <ul>
                  <!-- <li>
                    <strong>Corporate Identity Number (CIN):</strong>
                    U47912PB2026PTC068742.
                  </li> -->
                  <li>
                    <strong>Registered Office:</strong> 5 New Lajpat Nagar,
                    Ludhiana, Bharat Nagar Chowk, Ludhiana - 141001, Punjab.
                  </li>
                  <!-- <li>
                    <strong>Permanent Account Number (PAN):</strong> AAICI9547D.
                  </li> -->
                </ul>
              </div>

              <div class="faq-item">
                <p class="faq-q">
                  Q: Does the company comply with Indian Direct Selling
                  regulations?
                </p>
                <p class="faq-a">
                  A: Absolutely. The company's Memorandum of Association (e-MOA)
                  explicitly states its primary object is to carry on the
                  business of Direct Selling in accordance with applicable laws.
                  It operates under the Consumer Protection (Direct Selling)
                  Rules, 2021, and the Consumer Protection Act, 2019.
                </p>
              </div>
            </div>

            <!-- Section 2 -->
            <div class="policy-block reveal">
              <h3>Section 2: Business Model & Direct Selling</h3>

              <div class="faq-item">
                <p class="faq-q">
                  Q: What is the business model of IndieKonnect?
                </p>
                <p class="faq-a">
                  A: <strong>IndieKonnect</strong> is a direct selling entity
                  that markets and distributes lifestyle products — such as
                  Watches, Jewelry, Beauty, Personal Care, and Dining
                  Accessories — directly to consumers through a network of
                  Independent Brand Affiliates.
                </p>
              </div>

              <div class="faq-item">
                <p class="faq-q">
                  Q: Is IndieKonnect a Pyramid Scheme or an investment program?
                </p>
                <p class="faq-a">
                  A: No. <strong>IndieKonnect</strong> is <strong>not</strong> a
                  Pyramid Scheme, Money Circulation Scheme, or "get-rich-quick"
                  program.
                </p>
                <ul>
                  <li>
                    <strong>No Recruitment Fees:</strong> There are no fees
                    charged for joining, registration, or enrollment.
                  </li>
                  <li>
                    <strong>Sales-Based Compensation:</strong> Compensation is
                    earned strictly through the sale of genuine products to
                    consumers, not for the mere recruitment of new members.
                  </li>
                  <li>
                    <strong>No Guaranteed Income:</strong> Earnings are
                    illustrative and vary based on individual effort and sales
                    performance.
                  </li>
                </ul>
              </div>

              <div class="faq-item">
                <p class="faq-q">Q: How do Brand Affiliates earn money?</p>
                <p class="faq-a">
                  A: Brand Affiliates can earn through several streams,
                  including:
                </p>
                <ul>
                  <li>
                    <strong>Retail Profit:</strong> The difference between the
                    discounted Brand Affiliate price and the retail price.
                  </li>
                  <li>
                    <strong>Step Commissions:</strong> Commissions based on
                    product sales volume (Commissionable Volume) within their
                    network.
                  </li>
                  <li>
                    <strong>Incentives:</strong> Rank advancement bonuses and
                    reward programs like "IndieKonnect Coins".
                  </li>
                </ul>
              </div>
            </div>

            <!-- Section 3 -->
            <div class="policy-block reveal">
              <h3>Section 3: Consumer Protection & Rights</h3>

              <div class="faq-item">
                <p class="faq-q">
                  Q: What protections are available to Consumers and Brand
                  Affiliates?
                </p>
                <p class="faq-a">
                  A: <strong>IndieKonnect</strong> provides robust safeguards as
                  mandated by the Direct Selling Rules:
                </p>
                <ul>
                  <li>
                    <strong>Cooling-off Period:</strong> Brand Affiliates have a
                    30-day period from joining to cancel their agreement and
                    return unsold, marketable products for a refund.
                  </li>
                  <li>
                    <strong>Product Returns:</strong> Consumers can request
                    returns or refunds for damaged or defective products in
                    accordance with the company's Return Policy.
                  </li>
                  <li>
                    <strong>Transparency:</strong> All products are issued with
                    valid invoices including GST, and packaging contains
                    mandatory details like MRP and manufacturer info.
                  </li>
                </ul>
              </div>

              <div class="faq-item">
                <p class="faq-q">Q: How does the company handle grievances?</p>
                <p class="faq-a">
                  A: The company has a designated Grievance Redressal Committee
                  and a Nodal Officer to address complaints.
                </p>
                <ul>
                  <li>
                    <strong>Acknowledgement:</strong> Complaints are
                    acknowledged within 48 working hours.
                  </li>
                  <li>
                    <strong>Resolution:</strong> Most issues are resolved within
                    30 working days, with a maximum period of 45 working days.
                  </li>
                </ul>
              </div>
            </div>

            <!-- Section 4 -->
            <div class="policy-block reveal">
              <h3>Section 4: Ethical Conduct</h3>

              <div class="faq-item">
                <p class="faq-q">
                  Q: What are the requirements to become a Brand Affiliate?
                </p>
                <p class="faq-a">
                  A: Applicants must be at least 18 years old, complete a
                  registration process, submit valid KYC documents (including
                  PAN and Aadhaar), and sign a formal Direct Seller Agreement.
                </p>
              </div>

              <div class="faq-item">
                <p class="faq-q">
                  Q: How can I verify the authenticity of a Brand Affiliate?
                </p>
                <p class="faq-a">
                  A: All legitimate Brand Affiliates are required to carry
                  identity cards issued by the company and must clearly identify
                  themselves and IndieKonnect during any sales presentation.
                </p>
              </div>
            </div>

            <!-- Section 5 -->
            <div class="policy-block reveal">
              <h3>Section 5: Business Opportunity</h3>

              <div class="faq-item">
                <p class="faq-q">
                  Q: Who can join the IndieKonnect business network?
                </p>
                <p class="faq-a">
                  A: Any individual in India who wishes to build an independent
                  business can join as an IndieKonnect Brand Affiliate. To get
                  started, you need to achieve Qualified status and complete the
                  activation process as prescribed by IndieKonnect. For further
                  eligibility criteria, contact your upline or visit
                  indiekonnect.com.
                </p>
              </div>

              <div class="faq-item">
                <p class="faq-q">
                  Q: How does the IndieKonnect direct selling model work?
                </p>
                <p class="faq-a">
                  A: IndieKonnect operates through 5 income streams:
                </p>
                <ul>
                  <li>
                    <strong>Retail Profit:</strong> You buy products at a Brand
                    Affiliate discounted price and sell to customers at the
                    retail price, keeping the difference immediately.
                  </li>
                  <li>
                    <strong>Step Commission:</strong> Your business has a left
                    and right side. When you accumulate 1,800 Commissionable
                    Volume (CV) on both sides, you complete one "step" and earn
                    ₹23,500.
                  </li>
                  <li>
                    <strong>IndieKonnect Coins:</strong> (Green, Yellow & Blue)
                    Coins allow you to earn even before you balance both sides.
                  </li>
                  <li>
                    <strong>Rank Advancement Bonuses:</strong> As you achieve
                    higher ranks (Silver Star to Diamond Star), you unlock
                    higher step commissions, more weekly steps, and special
                    bonuses.
                  </li>
                  <li>
                    <strong>Strong Leg Matching Bonus:</strong> A monthly bonus
                    earned as a percentage of your downline leaders'
                    commissions, up to 10 levels deep.
                  </li>
                </ul>
              </div>

              <div class="faq-item">
                <p class="faq-q">
                  Q: Do I need prior sales experience to succeed with
                  IndieKonnect?
                </p>
                <p class="faq-a">
                  A: No prior sales experience is required. The IndieKonnect
                  compensation plan is designed to be simple and scalable. Your
                  fastest path to earning is through Retail Profit sharing
                  products with friends and family, while Step Commissions and
                  Coins help you build a sustainable income over time. Training
                  and support are available through your upline.
                </p>
              </div>

              <div class="faq-item">
                <p class="faq-q">
                  Q: What kind of earning can I expect as an IndieKonnect
                  associate?
                </p>
                <p class="faq-a">
                  A: Earnings depend on your rank, effort, and team performance.
                  Here is an overview of weekly maximum commissions by rank:
                </p>
                <div class="earnings-table-wrap">
                  <table class="earnings-table">
                    <thead>
                      <tr>
                        <th>Rank</th>
                        <th>Step Commission</th>
                        <th>Max Weekly Steps</th>
                        <th>Weekly Max Commission</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Silver Star</td>
                        <td>₹11,750 (Steps 1&2) + ₹23,500 from Green Coins</td>
                        <td>—</td>
                        <td>—</td>
                      </tr>
                      <tr>
                        <td>Titanium Star</td>
                        <td>₹23,500</td>
                        <td>20</td>
                        <td>₹3,99,500</td>
                      </tr>
                      <tr>
                        <td>Gold Star</td>
                        <td>₹23,500</td>
                        <td>50</td>
                        <td>₹9,87,000</td>
                      </tr>
                      <tr>
                        <td>Platinum Star</td>
                        <td>₹23,500</td>
                        <td>65</td>
                        <td>₹12,92,500</td>
                      </tr>
                      <tr>
                        <td>Sapphire Star</td>
                        <td>₹23,500</td>
                        <td>70</td>
                        <td>₹13,86,500</td>
                      </tr>
                      <tr>
                        <td>Ruby Star</td>
                        <td>₹24,910</td>
                        <td>75</td>
                        <td>₹15,69,330</td>
                      </tr>
                      <tr>
                        <td>Emerald Star</td>
                        <td>₹25,850</td>
                        <td>90</td>
                        <td>₹19,38,750</td>
                      </tr>
                      <tr>
                        <td>Diamond Star</td>
                        <td>₹26,790</td>
                        <td>105</td>
                        <td>₹23,57,520</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Section 6 -->
            <div class="policy-block reveal">
              <h3>Section 6: IndieKonnect Coins</h3>

              <div class="faq-item">
                <p class="faq-q">Q: What are IndieKonnect Coins?</p>
                <p class="faq-a">
                  A: IndieKonnect Coins are a distinctive feature of the
                  compensation plan that allows Brand Affiliates to earn income
                  even when only one side of their binary network is growing.
                  Most companies only pay when you balance both sides.
                  IndieKonnect pays you for building. There are three types of
                  coins: Green, Yellow, and Blue.
                </p>
              </div>

              <div class="faq-item">
                <p class="faq-q">
                  Q: What are Green IndieKonnect Coins and how do I earn them?
                </p>
                <p class="faq-a">
                  A: Every IndieKonnect product sold carries a CV value and
                  comes with Green Coins. The number of coins varies by product.
                  Green Coins are earned from product sales or purchases made by
                  people in the first 6 levels below you in your unilevel (Line
                  of Sponsorship) structure. You do not earn Green Coins from
                  your own purchases. Green Coins are relevant for your first 2
                  Steps and are convertible to cash as follows:
                </p>
                <div class="earnings-table-wrap">
                  <table class="earnings-table">
                    <thead>
                      <tr>
                        <th>Green Coins</th>
                        <th>Conversion Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>3</td>
                        <td>₹3,760</td>
                      </tr>
                      <tr>
                        <td>6</td>
                        <td>₹11,750</td>
                      </tr>
                      <tr>
                        <td>12</td>
                        <td>₹23,500</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p class="faq-note">
                  <em
                    >Important: A maximum of 12 Green Coins can be converted per
                    Brand Affiliate. After converting 12, no further Green Coin
                    conversion is allowed.</em
                  >
                </p>
              </div>

              <div class="faq-item">
                <p class="faq-q">
                  Q: How do Green Coins work for my first 2 steps?
                </p>
                <p class="faq-a">
                  A: For your first 2 Steps, your Step Commission of ₹23,500 is
                  split into two parts: ₹11,750 for balancing both sides (left
                  and right CV), and ₹11,750 that can be earned by converting
                  Green Coins. This means even if your left and right sides are
                  unequal, you can still convert your Green Coins to earn up to
                  ₹23,500. After your first 2 Steps, every step pays out the
                  full ₹23,500 directly.
                </p>
              </div>

              <div class="faq-item">
                <p class="faq-q">
                  Q: What are Blue IndieKonnect Coins and how do I earn them?
                </p>
                <p class="faq-a">
                  A: You (and your downlines up to 3 levels below you) can earn
                  Blue IndieKonnect Coins when you achieve specific criteria
                  during promotions or bonanzas held by IndieKonnect, such as:
                </p>
                <ul>
                  <li>
                    Registering downlines and prospects who attend specific
                    events
                  </li>
                  <li>Bringing in a set number of Direct Referrals</li>
                  <li>Achieving certain ranks within specified timelines</li>
                  <li>
                    Having a targeted number of retail customers or hitting
                    retail sales targets.
                  </li>
                </ul>
              </div>
            </div>

            <!-- Section 7 -->
            <div class="policy-block reveal">
              <h3>Section 7: Bonuses & Star Ranks</h3>

              <div class="faq-item">
                <p class="faq-q">Q: What is the Strong Leg Matching Bonus?</p>
                <p class="faq-a">
                  A: The Strong Leg Matching Bonus is a monthly bonus paid by
                  IndieKonnect (not deducted from your downlines) as a
                  percentage of your downline team leaders' Step Commissions. To
                  qualify, you must be at Platinum rank or above, and you can
                  earn from Gold rank and above Brand Affiliates within your
                  unilevel structure. The bonus spans 10 levels from your Strong
                  Leg, with percentages ranging from 10% at Level 1 down to 1%
                  at Level 10. Note: this bonus is capped at a certain
                  percentage of monthly revenue; if the cap is exceeded, bonuses
                  are reduced on a pro-rated basis.
                </p>
              </div>

              <div class="faq-item">
                <p class="faq-q">Q: What are the Rank Advancement Bonuses?</p>
                <p class="faq-a">
                  A: As you progress through the IndieKonnect Star Ranks and
                  build your business, you become eligible for a range of
                  enhanced benefits and rewards. These include higher Step
                  Commission earnings, reaching up to ₹26,790 per step at the
                  Diamond Star rank, an increased number of weekly steps (up to
                  105 at Diamond Star), access to additional Matching Bonus
                  levels, rank maintenance bonuses, and various special
                  recognition programs and rewards designed to acknowledge and
                  incentivise your achievements.
                </p>
              </div>

              <div class="faq-item">
                <p class="faq-q">Q: What is the Rank Maintenance Bonus?</p>
                <p class="faq-a">
                  A: If you maintain the Emerald Star or Diamond Star rank for 6
                  consecutive months, you receive a one-time Rank Maintenance
                  Bonus: ₹9,40,000 for Emerald Star and ₹28,20,000 for Diamond
                  Star.
                </p>
              </div>

              <div class="faq-item">
                <p class="faq-q">
                  Q: What are the Star Ranks and their qualification
                  requirements?
                </p>
                <p class="faq-a">
                  A: IndieKonnect has eight Star Ranks, each with specific
                  qualification criteria:
                </p>
                <ul>
                  <li>
                    <strong>Silver Star:</strong> Achieve Silver Star Qualified
                    status.
                  </li>
                  <li>
                    <strong>Titanium Star:</strong> Be Qualified and Activated,
                    and complete 2 steps (one-time requirement).
                  </li>
                  <li>
                    <strong>Gold Star:</strong> Achieve Titanium Star and
                    complete 10 steps.
                  </li>
                  <li>
                    <strong>Platinum Star:</strong> Achieve Gold Star and
                    complete 20 steps.
                  </li>
                  <li>
                    <strong>Sapphire Star:</strong> Achieve Platinum Star,
                    complete 40 steps, maintain 600 Direct CV, and have 5
                    downlines with a Platinum Star pay rank or higher within the
                    unilevel organization.
                  </li>
                  <li>
                    <strong>Ruby Star:</strong> Achieve Sapphire Star, complete
                    110 steps, maintain 600 Direct CV, have 5 downlines with a
                    Sapphire Star pay rank or higher, and 10 downlines with a
                    Platinum Star pay rank or higher.
                  </li>
                  <li>
                    <strong>Emerald Star:</strong> Achieve Ruby Star, complete
                    190 steps, maintain 1,200 Direct CV, have 1 downline with a
                    Ruby Star pay rank or higher, have 30 downlines with a
                    Sapphire Star pay rank, and satisfy all Emerald Star
                    requirements for two consecutive months.
                  </li>
                  <li>
                    <strong>Diamond Star:</strong> Achieve Emerald Star,
                    complete 310 steps, maintain 1,800 Direct CV, have 2
                    downlines with an Emerald Star pay rank or higher, have 10
                    downlines with a Ruby Star pay rank, and satisfy all Diamond
                    Star requirements for three consecutive months.
                  </li>
                </ul>
              </div>

              <div class="faq-item">
                <p class="faq-q">
                  Q: Are there any year-round incentives or special promotions?
                </p>
                <p class="faq-a">
                  A: Yes! Throughout the year, IndieKonnect offers special
                  promotions, product launch incentives, and achievement
                  rewards. Watch out for announcements on indiekonnect.com to
                  maximise your earnings. Recognition and rewards for top
                  achievers include: Exclusive IndieKonnect Achievers' Circle
                  merchandise, Recognition at company events, Featured success
                  stories, All-expense-paid travel incentives for top
                  performers, Personal invitations to exclusive leadership
                  events and much more.
                </p>
              </div>
            </div>

            <!-- Section 8 -->
            <div class="policy-block reveal">
              <h3>Section 8: Orders & Deliveries</h3>

              <div class="faq-item">
                <p class="faq-q">
                  Q: How do I place an order with IndieKonnect?
                </p>
                <p class="faq-a">
                  A: Orders can be placed through the official IndieKonnect
                  platform at indiekonnect.com. As a Brand Affiliate, you can
                  purchase products at your discounted price and arrange
                  delivery to your customers. For step-by-step guidance, contact
                  your upline or reach out to IndieKonnect support.
                </p>
              </div>

              <div class="faq-item">
                <p class="faq-q">
                  Q: What payment methods are accepted and how long does
                  delivery take?
                </p>
                <p class="faq-a">
                  A: We offer several online payment options, including
                  credit/debit cards, net banking, UPI and popular digital
                  wallets like Paytm, PayPal, and Google Pay. The standard
                  delivery orders will be delivered within:
                </p>
                <ul>
                  <li>
                    Standard Delivery: 1-3 business days from the order date.
                  </li>
                  <li>
                    Regional Delivery: 3-7 business days from the order date
                    (depending on geographical terrain).
                  </li>
                  <li>
                    Extended Area Delivery: 7-10 business days from the order
                    date (for remote locations).
                  </li>
                </ul>
              </div>
            </div>

            <!-- Section 9 -->
            <div class="policy-block reveal">
              <h3>Section 9: Returns & Customer Support</h3>

              <div class="faq-item">
                <p class="faq-q">
                  Q: What is IndieKonnect's return/cancellation policy?
                </p>
                <p class="faq-a">
                  A: IndieKonnect follows a return and cancellation policy in
                  compliance with Indian Direct Selling Guidelines. If you are
                  unsatisfied with a product, please contact IndieKonnect
                  customer support through indiekonnect.com within the
                  applicable return window. Full policy details are available on
                  the official website or from your upline.
                </p>
              </div>

              <div class="faq-item">
                <p class="faq-q">
                  Q: My order arrived damaged. What should I do?
                </p>
                <p class="faq-a">
                  A: If your order arrives damaged, please contact IndieKonnect
                  customer support immediately through indiekonnect.com.
                  Document the damage with photographs and retain all original
                  packaging. The support team will guide you through the
                  replacement or refund process in line with the company's
                  return policy.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <FooterView />
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import AppNavbar from "../AppNavbar.vue";
import FooterView from "../FooterView.vue";

onMounted(() => {
  const body = document.body;
  if (body) {
    body.style.setProperty("margin", "0", "important");
    body.style.setProperty("padding", "0", "important");
    body.style.setProperty("max-width", "100%", "important");
  }

  const revealElements = document.querySelectorAll(".reveal");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        }
      });
    },
    { threshold: 0.08 },
  );
  revealElements.forEach((el) => observer.observe(el));
});
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700;800&display=swap");

* {
  box-sizing: border-box;
}

.faq-page-root {
  width: 100vw !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  font-family: "Raleway", sans-serif;
  background: #f7f9fc;
  color: #333f48;
  overflow-x: hidden;
}

.hero-full-bleed-row {
  width: 100% !important;
  background: #003da5 !important;
  display: block;
}

.faq-hero {
  width: 100% !important;
  max-width: 1240px;
  margin: 0 auto;
  padding: 30px 24px 20px;
}

.hero-content {
  width: 100%;
  max-width: 820px;
}

.eyebrow {
  color: #ffc72c;
  font-size: 12px;
  letter-spacing: 2px;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 5px;
}

.faq-hero h1 {
  color: white;
  font-size: 40px;
  line-height: 1.23;
  margin-bottom: 18px;
  font-weight: 800;
}

.hero-description {
  color: rgba(255, 255, 255, 0.85);
  font-size: 16px;
  line-height: 1.7;
  max-width: 650px;
}

.content-full-bleed-row {
  width: 100% !important;
  background: #f7f9fc;
  display: block;
}

.faq-section {
  width: 100% !important;
  padding: 20px 0 60px;
}

.faq-wrapper {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 24px;
}

/* BLOCKS */
.policy-block {
  margin-bottom: 42px;
}

.policy-block h2 {
  font-size: 28px;
  color: #003da5;
  margin-bottom: 18px;
  font-weight: 800;
}

.policy-block h3 {
  font-size: 22px;
  color: #003da5;
  margin-bottom: 20px;
  font-weight: 800;
  padding-bottom: 10px;
  border-bottom: 2px solid rgba(0, 61, 165, 0.1);
}

/* AT A GLANCE */
.at-a-glance {
  background: rgba(0, 61, 165, 0.04);
  border-left: 4px solid #003da5;
  border-radius: 0 10px 10px 0;
  padding: 18px 22px;
}

.at-a-glance p {
  font-size: 15px;
  line-height: 1.9;
  color: #4c5661;
  margin: 0;
}

/* FAQ ITEMS */
.faq-item {
  background: #ffffff;
  border: 1px solid rgba(0, 61, 165, 0.08);
  border-radius: 12px;
  padding: 22px 24px;
  margin-bottom: 14px;
}

.faq-q {
  font-size: 15px;
  font-weight: 700;
  color: #003da5;
  margin-bottom: 10px;
  line-height: 1.6;
}

.faq-a {
  font-size: 15px;
  line-height: 1.9;
  color: #4c5661;
  margin-bottom: 10px;
}

.faq-a:last-child {
  margin-bottom: 0;
}

.faq-note {
  font-size: 13.5px;
  line-height: 1.8;
  color: #5f6368;
  margin-top: 10px;
  margin-bottom: 0;
}

/* LISTS inside FAQ items */
.faq-item ul {
  margin: 8px 0 4px 0;
  padding-left: 22px;
}

.faq-item ul li {
  font-size: 15px;
  line-height: 1.9;
  color: #4c5661;
  margin-bottom: 6px;
  list-style-type: disc;
}

/* TABLES */
.earnings-table-wrap {
  overflow-x: auto;
  margin: 14px 0 4px;
  border-radius: 10px;
  border: 1px solid rgba(0, 61, 165, 0.1);
}

.earnings-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  font-family: "Raleway", sans-serif;
}

.earnings-table thead tr {
  background: #003da5;
}

.earnings-table thead th {
  color: #ffffff;
  font-weight: 700;
  padding: 12px 16px;
  text-align: left;
  font-size: 13px;
  letter-spacing: 0.3px;
}

.earnings-table tbody tr {
  border-bottom: 1px solid rgba(0, 61, 165, 0.07);
  transition: background 0.15s;
}

.earnings-table tbody tr:last-child {
  border-bottom: none;
}

.earnings-table tbody tr:nth-child(even) {
  background: rgba(0, 61, 165, 0.03);
}

.earnings-table tbody tr:hover {
  background: rgba(255, 199, 44, 0.08);
}

.earnings-table tbody td {
  padding: 11px 16px;
  color: #333f48;
  font-weight: 500;
  line-height: 1.6;
}

/* REVEAL */
.reveal {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.8s ease;
}

.reveal.active {
  opacity: 1;
  transform: translateY(0);
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .faq-hero {
    padding: 40px 20px 26px;
  }

  .faq-hero h1 {
    font-size: 20px;
  }

  .faq-section {
    padding: 20px 0 40px;
  }

  .faq-wrapper {
    padding: 0 20px;
  }

  .policy-block h2 {
    font-size: 22px;
  }

  .policy-block h3 {
    font-size: 18px;
  }

  .faq-item {
    padding: 18px 16px;
  }

  .faq-q,
  .faq-a,
  .faq-item ul li {
    font-size: 14px;
  }

  .earnings-table thead th,
  .earnings-table tbody td {
    padding: 10px 12px;
    font-size: 13px;
  }
}
</style>
